// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const BestPracticesGradientIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#best-practices-gradient_svga)"
      d="M24.31 12.93a1.07 1.07 0 0 0-1.53 0l-4.23 4.24-1.34-1.34a1.08 1.08 0 0 0-1.53 1.54l2.1 2.1a1.1 1.1 0 0 0 1.53 0l5-5a1.1 1.1 0 0 0 0-1.54"
    />
    <path
      fill="url(#best-practices-gradient_svgb)"
      d="M31.88 21.53v-2.45l1.2-2.13a2.2 2.2 0 0 0 0-2.12l-1.2-2.13v-2.45a2.1 2.1 0 0 0-1.05-1.83l-2.12-1.25L27.46 5a2.2 2.2 0 0 0-1.83-1.07H23.2l-2.15-1.18a2.1 2.1 0 0 0-2.1 0L16.8 3.93h-2.44A2.2 2.2 0 0 0 12.53 5l-1.25 2.17-2.12 1.25a2.1 2.1 0 0 0-1.05 1.83v2.45l-1.23 2.13a2.2 2.2 0 0 0 0 2.12l1.2 2.13v2.45a2.1 2.1 0 0 0 1.08 1.8l1.27.75-3.47 9.52a.8.8 0 0 0 .22.9.8.8 0 0 0 .92.15l4.43-2.07 2.07 4.44a.8.8 0 0 0 .75.48.9.9 0 0 0 .75-.55l2.88-7.92a2.1 2.1 0 0 0 1.97 0l2.88 7.92a.9.9 0 0 0 .75.55.8.8 0 0 0 .75-.48l2.07-4.44 4.43 2.07a.8.8 0 0 0 .92-.15.8.8 0 0 0 .21-.9l-3.46-9.48 1.33-.79a2.1 2.1 0 0 0 1.05-1.8M15.21 34.5l-1.56-3.33a.8.8 0 0 0-.75-.49 1 1 0 0 0-.35 0L9.2 32.27l2.45-6.89.8 1.34a2.2 2.2 0 0 0 1.84 1.06h2.43l.75.42zm12.17-3.78a.83.83 0 0 0-1.1.41l-1.57 3.34-2.3-6.29.75-.41h2.44a2.2 2.2 0 0 0 1.83-1.07l.8-1.33 2.52 6.91zm2.3-9.22-2.57 1.53-1.53 2.59h-3L20 27.12l-2.62-1.47h-3l-1.53-2.58-2.57-1.57v-3l-1.52-2.62 1.47-2.55v-3L12.8 8.8l1.58-2.63h3L20 4.67l2.61 1.46h3l1.54 2.59 2.56 1.53v3l1.47 2.6-1.47 2.62z"
    />
    <defs>
      <linearGradient
        id="best-practices-gradient_svga"
        x1={15.36}
        x2={22.57}
        y1={12.61}
        y2={21.46}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="best-practices-gradient_svgb"
        x1={6.61}
        x2={40.78}
        y1={2.47}
        y2={27.27}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "BestPracticesGradient",
);
export default BestPracticesGradientIcon;
